import { render, staticRenderFns } from "./income_history.vue?vue&type=template&id=598bd5d6&scoped=true"
import script from "./income_history.vue?vue&type=script&lang=js"
export * from "./income_history.vue?vue&type=script&lang=js"
import style0 from "./income_history.vue?vue&type=style&index=0&id=598bd5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598bd5d6",
  null
  
)

export default component.exports